export default __webpack_public_path__ + "static/media/mobile_azul_logo_hyundai.61aa9674.svg";